export default __webpack_public_path__ + "static/media/route-red.efab8fda.svg";